import { render, staticRenderFns } from "./MarketplaceDetail.vue?vue&type=template&id=1a17d7e9&scoped=true"
import script from "./MarketplaceDetail.vue?vue&type=script&lang=js"
export * from "./MarketplaceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a17d7e9",
  null
  
)

export default component.exports